import { Component, EventEmitter, Inject, Input, OnChanges, OnDestroy, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';

import { CimaCore, Cloudinary, Decorator, GlobalNav, LinkDecorationInfo, Util, XmStore, XmStoreUtil } from 'core/services';
import { CmsCore } from 'store/cms/models';
import { CONFIG_TOKEN, MouseEventType } from 'core/constants';
import { IXMOptions } from 'core/interfaces';

@Component({
    selector: 'xm-nav-menu-item',
    styleUrls: ['./menu-item.scss'],
    templateUrl: './menu-item.html',
    standalone: false
})
export class XmNavMenuItemComponent implements OnInit, OnDestroy, OnChanges {
    @Input() public pageData: CmsNavMenuItems;
    @Input() public myAccountChildItems: boolean;
    @Input() public showChildren: boolean;
    @Input() public inheritParentWidth: boolean;
    // DO NOT DELETE this input variable (triggerOnChanges) check primary.html for usage
    @Input() public triggerOnChanges: boolean;
    @Output() public toggleMobileNav: EventEmitter<boolean> = new EventEmitter<boolean>();

    public menuIcon: MediaImageOptions;
    public caretIcon: MediaImageOptions;
    public showChildItems: boolean;

    public isChat: boolean;
    public isCart: boolean;
    public isSeparator: boolean;
    public isFullName: boolean = false;

    private subscriptions: Subscription[] = [];
    private xmStore: XmStore;
    private globalNav: GlobalNav;
    private decorator: Decorator;
    private cimaCore: CimaCore;
    private config: IXMOptions;

    constructor(globalNav: GlobalNav, xmStore: XmStore, decorator: Decorator, cimaCore: CimaCore, @Inject(CONFIG_TOKEN) config: IXMOptions) {
        Object.assign(this, { globalNav, xmStore, decorator, cimaCore, config });
    }

    public ngOnInit(): void {
        this.subscriptions.push(XmStoreUtil.subscribe(this.xmStore.peek<CmsCore>(CmsCore), (result: CmsCore) => {
            this.caretIcon = { mobile: Cloudinary.generateMediaFromCms(result.nav.caretIcon) };
        }));

        if (this.pageData.icon) {
            this.menuIcon = { mobile: Cloudinary.generateMediaFromCms(this.pageData.icon) };
        }

        this.isChat = this.pageData.isChat;
        this.isCart = this.pageData.isCart;
        this.isFullName = this.pageData.isFullName;
        this.isSeparator = this.pageData.isSeparator;
    }

    public ngOnChanges(): void {
        this.buildLinkItems();
    }

    public ngOnDestroy(): void {
        Util.unsubscribeAll(this.subscriptions);
    }

    public stateActive(): boolean {
        if (this.pageData) {
            return this.globalNav.stateActive(this.pageData);
        }
    }

    public generateCmsMediaImage(icon: CmsMediaImage): MediaImageOptions {
        if (!icon) {
            return undefined;
        }

        return { mobile: Cloudinary.generateMediaFromCms(icon) };
    }

    public generateUiParams(paramsString: string): object {
        return Util.getObjectFromQueryString(paramsString);
    }

    public closeMobileMenu(): void {
        this.toggleMobileNav.emit();
        this.showChildItems = false;
    }

    public expandChildItems(): void {
        this.showChildItems = !this.showChildItems;
    }

    public mouseHoverEvent(event: Event): void {
        this.showChildItems = event.type === MouseEventType.MOUSE_ENTER;
    }

    public get isBusinessUser(): boolean {
        return this.cimaCore.isBusinessUser;
    }

    private buildLinkItems(): void {
        const linkDecoration: string | undefined = this.config.ENABLE_BUYFLOW_CONVERGENCE_URL && this.pageData.linkDecorationBuyFlow
            ? this.pageData.linkDecorationBuyFlow
            : this.pageData.linkDecoration;

        if (linkDecoration) {
            const deco: LinkDecorationInfo = this.decorator.parseLinkDecoration(this.resolvePaymentBaseUrl(linkDecoration))[0];
            this.pageData.uiSref = deco.uiSref;
            this.pageData.uiParams = Util.createQueryParams(deco.uiParams).replace('?', '');
            this.pageData.url = deco.absoluteUrl;
        }

        if (this.pageData.children) {
            this.pageData.children = this.pageData.children.map((navMenuItem: CmsNavMenuItems) => {
                const childLinkDecoration: string | undefined = this.config.ENABLE_BUYFLOW_CONVERGENCE_URL && navMenuItem.linkDecorationBuyFlow
                    ? navMenuItem.linkDecorationBuyFlow
                    : navMenuItem.linkDecoration;

                if (!childLinkDecoration) {
                    return navMenuItem;
                }

                const deco: LinkDecorationInfo = this.decorator.parseLinkDecoration(this.resolvePaymentBaseUrl(childLinkDecoration))[0];
                navMenuItem.uiSref = deco.uiSref;
                navMenuItem.uiParams = Util.createQueryParams(deco.uiParams).replace('?', '');
                navMenuItem.url = deco.absoluteUrl;

                return navMenuItem;
            });
        }
    }

    private resolvePaymentBaseUrl(linkDecoration: string | undefined): string {
        return linkDecoration ? linkDecoration.replace('[PAYMENT_BASE_URL]', this.config.PAYMENT_BASE_URL) : linkDecoration;
    }
}
